module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    class: _vm.classFlag,
    attrs: {
      "title": _vm.selectedLan
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, _vm._l((_vm.languages), function(entry) {
    return _c('li', {
      key: entry.title
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.changeLocale(entry)
        }
      }
    }, [_c('flag', {
      attrs: {
        "iso": entry.flag,
        "squared": false
      }
    }), _vm._v(" " + _vm._s(entry.title))], 1)])
  }), 0)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', {
    staticClass: "dropdown notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.unreadNotificationsCount))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.unreadNotificationsCount) + " notifications")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown tasks-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.remainTasksCount))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.remainTasksCount) + " tasks")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.currentUser.name))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('img', {
    staticClass: "img-circle",
    attrs: {
      "src": _vm.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.currentUser.name) + " - " + _vm._s(_vm.$t('userType')[[_vm.currentUser.position - 1]]) + "\n                "), _c('small', [_vm._v(_vm._s(_vm.currentUser.createdAt))])])]), _vm._v(" "), _c('li', {
    staticClass: "user-footer"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "/profile"
    }
  }, [_vm._v(_vm._s(_vm.$t('profile')))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "/logout"
    }
  }, [_vm._v(_vm._s(_vm.$t('sign_out')))])])])])]), _vm._v(" "), _vm._m(7)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "\\"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_vm._v("H")]), _vm._v("Care")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('b', [_vm._v("Hotline")]), _vm._v(".CARE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v("0")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have 0 messages")]), _vm._v(" "), _c('li', [_c('ul', {
    staticClass: "menu"
  })]), _vm._v(" "), _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("See All Messages")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-aqua"
  }), _vm._v(" 5 new members joined today\n                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning text-yellow"
  }), _vm._v(" Very long description here that may not fit into the\n                    page and may cause design problems\n                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-users text-red"
  }), _vm._v(" 5 new patient joined\n                  ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart text-green"
  }), _vm._v(" 25 ration requested today\n                  ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View all")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("\n                      Patient with Minor symptoms\n                      "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("20%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("20% ")])])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("\n                      Patient with Major symptoms\n                      "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("40%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40% ")])])])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h3', [_vm._v("\n                      Unrecognized \n                      "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v("40%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress xs"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-red",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "20",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("40% ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View all tasks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "data-toggle": "control-sidebar"
    }
  }, [_c('i', {
    staticClass: "fa fa-gears"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48069dd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/NaviBar.vue
// module id = 713
// module chunks = 1